// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@cahaba/Overrides/Widgets/Basic/Subscribe";
import AwesomeEnvelope from "@cahaba/XDL/Icons/AwesomeEnvelope";
import { css } from "styled-components";

subscribeStyles.titleLabel = {
    variant: "h4",
    color: "primary.contrast",
    size: 40,
    weight: 300,
    transform: "uppercase",
    css: css`
        margin-bottom: 0;
        letter-spacing: 4px;
        line-height: normal;
    `,
};

subscribeStyles.descriptionText = {
    css: css`
        margin-bottom: 0;
    `,
};

subscribeStyles.emailTextField = {
    cssOverrides: {
        formField: css`
            max-width: 300px;
        `,
    },
};

subscribeStyles.emailButton = {
    buttonType: "solid",
    variant: "secondary",
    css: css`
        font-size: 15px;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 1px;
        min-height: 50px;
        width: 250px;
    `,
};

subscribeStyles.buttonGridItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

subscribeStyles.buttonIcon = {
    src: AwesomeEnvelope,
    size: 15,
    css: css`
        margin-right: 10px;
        svg {
            color: white;
            fill: white;
        }
    `,
};
